import { Typography } from 'antd';
import type { TagsTabPageViewProps } from './TagsTabPage.types';

export function TagsTabPageView({ title }: TagsTabPageViewProps) {
  return <Typography.Title level={3}>{title}</Typography.Title>;
}
